export default "__VITE_ASSET__6463143c__"